export { extractTrpcErrorProperties } from './extractTrpcErrorProperties';
